module.exports = __webpack_public_path__ + "img/3_EN_ChineseMicrosite_Homepage_HeroImage.b0b7ca4f.jpg";